import Vue from 'vue';

export default {
    namespaced: true,
    // -----------------------------------------------------------------
    state: {
        patients: [],
    },
    // -----------------------------------------------------------------
    getters: {
        all: (state) => { return state.patients },
        active: (state) => { return state.patients.filter((p) => p.paid && !p.completed_course) },
        inactive: (state) => { return state.patients.filter((p) => p.paid && p.completed_course) },
        trial: (state) => { return state.patients.filter((p) => !p.paid) },
    },
    // -----------------------------------------------------------------
    mutations: {
        SET_PATIENTS(state, patients) {
            state.patients = patients
        },
        PUSH_PATIENTS(state, patients) {
            state.patients = state.patients.concat(patients)
        }
    },
    // -----------------------------------------------------------------
    actions: {
        index: (context, data) => {
            return Vue.api.get('patients', { params: data })
                .then(response => {
                    context.commit((data.page === 1) ? 'SET_PATIENTS' : 'PUSH_PATIENTS', response.data.data)
                    return response.data
                })
                .catch(error => { throw error.response.data.error })
        },
        read: (context, id) => {
            return Vue.api.get(`patients/${id}`)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        invite: (context, data) => {
            return Vue.api.post('patient-invites', data)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        followUp: (context, { id, data }) => {
            return Vue.api.post(`patients/${id}/follow-up`, data)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        delete: (context, id) => {
            return Vue.api.delete(`patients/${id}`)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        viewed(context, { id, data }) {
            return Vue.api.post(`patients/${id}/viewed`, data)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        statistics(context) {
            return Vue.api.get(`patients/page-statistics`)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        }
    }
}
